import { validateImageSyncAsyncWithDimensionParams } from '@bingads-webui-campaign/image-experience-utils';

// Put all validations in this package along with the view
export const validateImageAsync = ({
  imageSource,
  minimumWidth,
  minimumHeight,
}) => validateImageSyncAsyncWithDimensionParams({
  imageSource,
  minimumWidth,
  minimumHeight,
});

// currently there is no client side check, so here leave an empty interface
export const validateVideoAsync = () => Promise.resolve(true);
